<!-- <p>asset-history works!</p>-->
<app-dialog-header *ngIf="asset" headerIcon="history"
    headerText="{{asset.Name}} - {{asset.Description}} Event & Action History"
    (onCloseClick)="onCancelClick()"></app-dialog-header>

<div class="main-history-div">
    <div [ngTemplateOutlet]="overviewBanner"></div>
    <ejs-tab id="element" headerPlacement="Top" [selectedItem]="selectedTab" (selected)="updateSelectedTab($event)">
        <e-tabitems>
            <e-tabitem *ngIf="assetHistory && assetHistory.CMMSCaseHistory.length > 0 && checkFeature(AccountFeatures.SAP)">
                <ng-template #headerText>
                    <span class="alignRow app-icon--sapCases">
                        <mat-icon/>&nbsp;CMMS Case History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory" [ngTemplateOutlet]="CMMSCases"></ng-container>
                </ng-template>
            </e-tabitem>
            <e-tabitem *ngIf="assetHistory && assetHistory.RuleEventHistory.length > 0">
                <ng-template #headerText>
                    <span class="alignRow app-icon--notifications">
                        <mat-icon/>&nbsp;Rule Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory" [ngTemplateOutlet]="ruleEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            <e-tabitem *ngIf="assetHistory && assetHistory.SensorEventHistory.length > 0">
                <ng-template #headerText>
                    <span class="alignRow app-icon--offline">
                        <mat-icon/>&nbsp;Sensor Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory" [ngTemplateOutlet]="sensorEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            <e-tabitem *ngIf="assetHistory && assetHistory.DeviationEventHistory.length > 0">
                <ng-template #headerText>
                    <span class="alignRow app-icon--models">
                        <mat-icon/>&nbsp;Deviation Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory" [ngTemplateOutlet]="deviationEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            <e-tabitem *ngIf="assetHistory && assetHistory.ActionHistory.length > 0">
                <ng-template #headerText>
                    <span class="alignRow app-icon--actions">
                        <mat-icon/>&nbsp;Action History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory  && checkFeature(AccountFeatures.Actions)" [ngTemplateOutlet]="actions"></ng-container>
                </ng-template>
            </e-tabitem>
        </e-tabitems>
    </ejs-tab>
</div>

<ng-template #overview>
    <div class="overview-div" *ngIf="assetHistory" [ngStyle]="{'grid-template-columns': getColumnDefinition()}">
        <div *ngIf="assetHistory.RuleEventHistory.length > 0" class="overview-section">
            <span class="overview-section-title">Rule Events</span>
            <button mat-raised-button color="primary"
                (click)="changeTab(1)"><span>History</span><mat-icon>north_east</mat-icon></button>
            <span>Total Events:</span>
            <span><b>{{assetHistory.RuleEventHistory.length}}</b></span>
            <span>Most Recent Event:</span>
            <span><b>{{convertEpoch(assetHistory.RuleEventHistory[0].TimeStamp)}}</b></span>
            <span>Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.RuleEventHistory.length}}</b></span>
        </div>
        <div *ngIf="assetHistory.SensorEventHistory.length > 0" class="overview-section">
            <span class="overview-section-title">Sensor Events</span>
            <button mat-raised-button color="primary"
                (click)="changeTab(2)"><span>History</span><mat-icon>north_east</mat-icon></button>
            <span>Total Events:</span>
            <span><b>{{assetHistory.SensorEventHistory.length}}</b></span>
            <span>Most Recent Event:</span>
            <span><b>{{convertEpoch(assetHistory.SensorEventHistory[0].TimeStamp)}}</b></span>
            <span>Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.SensorEventHistory.length}}</b></span>
        </div>
        <div *ngIf="assetHistory.ActionHistory.length > 0" class="overview-section">
            <span class="overview-section-title">Actions</span>
            <button mat-raised-button color="primary"
                (click)="changeTab(3)"><span>History</span><mat-icon>north_east</mat-icon></button>
            <span>Total Actions:</span>
            <span><b>{{assetHistory.ActionHistory.length}}</b></span>
            <span>Most Recent Action:</span>
            <span><b>{{convertEpoch(assetHistory.ActionHistory[0].Timestamp)}}</b></span>
            <span>Actions In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.ActionHistory.length}}</b></span>
        </div>
        <div *ngIf="numberOfColumns == 0">
            <span>This Asset has no Rule Event, Sensor Event, or Action history.</span>
        </div>
    </div>
</ng-template>

<ng-template #overviewBanner>
    <div class="banner-div" *ngIf="assetHistory"
        [ngStyle]="{'grid-template-columns': getColumnDefinition(), 'height': getBannerHeight()}">
        <div class="banner-column" *ngIf="assetHistory.RuleEventHistory.length > 0">
            <span>Total Rule Events:</span>
            <span><b>{{assetHistory.RuleEventHistory.length}}</b></span>
            <span>Most Recent Rule Event:</span>
            <span><b>{{convertEpoch(assetHistory.RuleEventHistory[0].TimeStamp)}}</b></span>
            <span>Rule Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.RuleEventHistory.length}}</b></span>
        </div>
        <div class="banner-column" *ngIf="assetHistory.SensorEventHistory.length > 0">
            <span>Total Sensor Events:</span>
            <span><b>{{assetHistory.SensorEventHistory.length}}</b></span>
            <span>Most Recent Sensor Event:</span>
            <span><b>{{convertEpoch(assetHistory.SensorEventHistory[0].TimeStamp)}}</b></span>
            <span>Sensor Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.SensorEventHistory.length}}</b></span>
        </div>
        <div class="banner-column" *ngIf="assetHistory.ActionHistory.length > 0">
            <span>Total Actions:</span>
            <span><b>{{assetHistory.ActionHistory.length}}</b></span>
            <span>Most Recent Action:</span>
            <span><b>{{convertEpoch(assetHistory.ActionHistory[0].Timestamp)}}</b></span>
            <span>Actions In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.ActionHistory.length}}</b></span>
        </div>
        <div class="banner-column" *ngIf="assetHistory.DeviationEventHistory.length > 0">
            <span>Total Deviation Events:</span>
            <span><b>{{assetHistory.DeviationEventHistory.length}}</b></span>
            <span>Most Recent Deviation Event:</span>
            <span><b>{{convertEpoch(assetHistory.DeviationEventHistory[0].Timestamp)}}</b></span>
            <span>Deviation Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.DeviationEventHistory.length}}</b></span>
        </div>
    </div>
</ng-template>

<ng-template #CMMSCases>
    <div class="cmms-case-item">
        <span>Trigger</span>
        <span>Description</span>
        <span>Opened</span>
        <span>Closed</span>
    </div>
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.CMMSCaseHistory' [fields]="fields5" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="rule-event-item ejs-listbox-item" (click)="goToItem(5, data.Id)">
                    <span>{{data.Trigger}}</span>
                    <span>{{data.Description}}</span>
                    <span>{{convertEpoch(data.OpenedAt)}}</span>
                    <span *ngIf="data.ClosedAt > 0">{{convertEpoch(data.ClosedAt)}}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #ruleEvents>
    <div class="rule-event-item">
        <span>Rule Name</span>
        <span>Conditions</span>
        <span>Values</span>
        <span>Timestamp</span>
    </div>
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.RuleEventHistory' [fields]="fields" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="rule-event-item ejs-listbox-item" (click)="goToItem(1, data.RuleEventID)">
                    <span>{{data.RuleName}}</span>
                    <span>{{data.RuleText}}</span>
                    <span>{{data.RuleValues}}</span>
                    <span>{{convertEpoch(data.TimeStamp)}}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #sensorEvents>
    <div class="sensor-event-item">
        <span>Sensor Name</span>
        <span>Event Type</span>
        <span>Timestamp</span>
    </div>
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.SensorEventHistory' [fields]="fields2" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="sensor-event-item ejs-listbox-item" (click)="goToItem(2, data.SensorEventID)">
                    <span>{{data.SensorName}}</span>
                    <!-- <span>{{data.SensorEventType}}</span> -->
                    <span>Sensor Offline</span>
                    <span>{{convertEpoch(data.TimeStamp)}}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #actions>
    <div class="action-item">
        <span>Action Type</span>
        <span>Details</span>
        <span>Target Completion Date</span>
        <span>Created By</span>
        <span>Created On</span>
        <span>Assigned To</span>
        <span>Completed</span>
        <span>Completed On</span>
    </div>
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.ActionHistory' [fields]="fields3" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="action-item ejs-listbox-item" (click)="goToItem(3, data.ActionID)">
                    <span>{{getActionTypeFromValue(data.ActionType)}}</span>
                    <span>{{data.Details}}</span>
                    <span>{{convertEpoch(data.TargetCompletionTimestamp)}}</span>
                    <span>{{data.CreatedByUserSub}}</span>
                    <span>{{convertEpoch(data.Timestamp)}}</span>
                    <span>{{data.AssignedToUserSub}}</span>
                    <span *ngIf="data.Completed">Yes</span>
                    <span *ngIf="!data.Completed">No</span>
                    <span *ngIf="data.Completed">{{convertEpoch(data.CompletedTimestamp)}}</span>
                    <span *ngIf="!data.Completed">N/A</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #deviationEvents>
    <div class="deviation-event-item">
        <span>Model Type</span>
        <span>Z-Score</span>
        <span>Tolerance</span>
        <span>Sensitivity</span>
        <span>Timestamp</span>
    </div>
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.DeviationEventHistory' [fields]="fields4" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="deviation-event-item ejs-listbox-item" (click)="goToItem(4, data.RuleEventID)">
                    <span>{{getModelTypeName(data.ModelType)}}</span>
                    <span>{{data.ZScore}}</span>
                    <span>{{data.AcceptableDeviation}}</span>
                    <span>{{data.Sensitivity}}</span>
                    <span>{{convertEpoch(data.Timestamp)}}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>